
//LENS
ImageUrl["lens"] = [
  
	"//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/LENS_Black.png?v=166819782263651472461466433479",
	"//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/LENS_Yellow_to_Orange-2.png?v=67576858831105241901466433486",
	"//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/LENS_Green.png?v=156415552234668243771466433482",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/LENS_Ice_Blue.png?v=89909849717953061701466433483",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/LENS_Purple.png?v=13158434158392142741466433484",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/LENS_Brown2.png?v=170343184528158025031466433480"

  
];
//ARMS
ImageUrl["arms"] = [
  
	"//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/ARMS_Sili_Gloss_Black.png?v=62477869070067267491466433459",
	"//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/ARMS_Sili_Frosted_Pink.png?v=42466740991885833261466433459",
	"//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/ARMS_Sili_Frosted_Orange.png?v=139301171264385551211466433459",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/ARMS_Sili_Clear.png?v=57715870459835412891466433457",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/ARMS_Sili_Frosted_Blue.png?v=74652894555210231811466433457",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/ARMS_Sili_Frosted_Green.png?v=44090686037641941191466433458",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/ARMS_Sili_Frosted_Purple.png?v=166004969191669479381466433459",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/ARMS_Sili_Matte_Black.png?v=20629793610459492901466433460",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/ARMS_Sili_Matte_White.png?v=11232419527218903051466433460",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/ARMS_Sili_Tortoise.png?v=83592635961108980791466433461",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/ARMS_Sili_Frosted_Grey.png?v=180608726163680213321466433458"
  
];
//FRAME
ImageUrl["frame"] = [
  
	"//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/FRAME_Sili_Gloss_Black.png?v=680737957115182401466433472",
	"//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/FRAME_Sili_Frosted_Pink.png?v=106323479685235725611466433472",
	"//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/FRAME_Sili_Frosted_Orange.png?v=31690911450913306351466433471",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/FRAME_Sili_Clear.png?v=141414607243044581181466433470",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/FRAME_Sili_Frosted_Blue.png?v=148233907009960325771466433470",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/FRAME_Sili_Frosted_Green.png?v=96621938202969660761466433471",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/FRAME_Sili_Frosted_Purple.png?v=8379077203620069421466433472",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/FRAME_Sili_Matte_Black.png?v=16390871386374963801466433473",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/FRAME_Sili_Matte_White.png?v=58883979778723481466433473",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/FRAME_Sili_Tortoise.png?v=1121343237612785831466433474",
    "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/FRAME_Sili_Frosted_Grey.png?v=7238947617340891711466433471"
];


//BACKGOUND
BackgroundUrl = "//alphabeta-5.myshopify.com/cdn/shop/t/5/assets/background2.png?v=162434285336221270241466433464" ;